import axios from "axios";
import dataServiceConfig from "../../config/data-service.config";
import { TODESCHINI, CRIARE, ITALINEA } from "../../constants/appNames";
import { tokens } from "../../constants/appsToken";

const apiUrl = dataServiceConfig.REACT_APP_REMOTE_URL;

type appNames = typeof TODESCHINI | typeof ITALINEA | typeof CRIARE;

const resources = {
  START_JOURNEY: "/jornada/start",
  GET_CITIES: "/jornada/cidades",
  GET_STORES: "/jornada/lojas",
  GET_STORES_LINK: "/jornada/lojas-link",
  GET_WHATSAPP_LINK: "/jornada/watsappLink",
  GET_INVESTMENT: "/jornada/get-investment",
  SEND_SELECTED_IMAGES: "/jornada/galeria",
  SEND_IMAGE: "/jornada/image",
  FINISH_JOURNEY: "/jornada/finalizar",
  SEND_ANSWER: "/jornada",
  GET_STATES: "/jornada/estados",
};

export async function sendDatalessStep(step: string, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: step
  });

  return response.data;
}

export async function startJourney(appName: appNames) {
  let response;

  switch (appName) {
    case TODESCHINI:
      response = await axios.post(`${apiUrl}${resources.START_JOURNEY}`, {
        companyToken: tokens.TODESCHINI,
      });

      break;

    case ITALINEA:
      response = await axios.post(`${apiUrl}${resources.START_JOURNEY}`, {
        companyToken: tokens.ITALINEA,
      });
      break;

    case CRIARE:
      response = await axios.post(`${apiUrl}${resources.START_JOURNEY}`, {
        companyToken: tokens.CRIARE,
      });
      break;

    default:
      throw new Error("Invalid app name on startJourney call");
  }

  return response.data;
}

export async function getCities(state: string, token: string) {
  const response = await axios.post(`${apiUrl}${resources.GET_CITIES}`, {
    token,
    uf: state,
  });

  return response.data;
}

export async function getStores(cityId: number, token: string) {
  const response = await axios.post(`${apiUrl}${resources.GET_STORES}`, {
    token,
    cidade_id: cityId,
  });

  return response.data;
}

export async function getStoresByLink(link_tracking: string, token: string) {
  const response = await axios.post(`${apiUrl}${resources.GET_STORES_LINK}`, {
    token,
    link_tracking: link_tracking,
  });

  return response.data;
}

export async function finishJourney(storeId: number, token: string) {
  const response = await axios.post(`${apiUrl}${resources.FINISH_JOURNEY}`, {
    token,
    loja: storeId,
    etapa: "etapa_final",
  });

  return response.data.data.watsappData;
}

export async function finishJourneyEspecificador(storeId: number, token: string) {
  const response = await axios.post(`${apiUrl}${resources.FINISH_JOURNEY}`, {
    token,
    loja: storeId,
    etapa: "etapa_final_especificador",
  });

  return response.data.data.watsappData;
}

export async function getWhatsappLink(storeId: number, token: string) {
  const response = await axios.post(`${apiUrl}${resources.GET_WHATSAPP_LINK}`, {
    token,
    loja_id: storeId,
  });

  return response.data.data;
}

export async function getInvestment(token: string) {
  const response = await axios.post(`${apiUrl}${resources.GET_INVESTMENT}`, {
    token,
  });

  return response.data.comodos;
}

export async function sendInitial(answer: "sim" | "nao", token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_inicial",
    dados: {
      gostaria_de_saber_o_estilo: answer,
    },
  });

  return response.data;
}

export async function sendEspecificador(answer: "cliente" | "especificar", token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_especificador",
    dados: {
      etapa_especificador: answer,
    },
  });

  return response.data;
}

export async function sendClient(answer: "cliente" | "especificar", token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_cliente",
    dados: {
      etapa_cliente: answer,
    },
  });

  return response.data;
}

export async function sendSelectedImages(images: number[], token: string) {
  const response = await axios.post(
    `${apiUrl}${resources.SEND_SELECTED_IMAGES}`,
    {
      token,
      imagens: images,
    }
  );

  return response.data;
}

export async function sendPersonalData(dados: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: dados?.email ? "etapa_email" : (dados?.whats ? "etapa_whats" : "etapa_dados_pessoais"),
    dados: { ...dados },
  });

  return response.data;
}

export async function sendPlant(imagem: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_IMAGE}`, {
    token,
    imagem: imagem,
    etapa: "etapa_planta"
  });
  return response.data;
}

export async function sendPlantEspecificador(imagem: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_IMAGE}`, {
    token,
    imagem: imagem,
    etapa: "etapa_especificador_planta"
  });
  return response.data;
}

export async function sendIfThereIsAnArchitect(
  answer: "sim" | "nao",
  token: string
) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_possui_arquiteto",
    dados: {
      possui_arquiteto: answer,
    },
  });

  return response.data;
}

export async function sendArchitectData(dados: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_dados_arquiteto",
    dados: { ...dados },
  });

  return response.data;
}

export async function sendArchitectEspecicadorData(dados: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_especificador_dados_arquiteto",
    dados: { ...dados },
  });

  return response.data;
}

export async function sendTimeExpectationEspecificador(dados: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_especificador_expectativa_de_tempo",
    dados: { ...dados },
  });
  return response.data;
}

export async function sendTimeExpectation(dados: any, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_expectativa_de_tempo",
    dados: { ...dados },
  });
  return response.data;
}

export async function sendConvenient(furniture: string[], token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_comodos",
    dados: {
      comodos: furniture.join(", "),
    },
  });

  return response.data;
}

export async function sendConvenientEspecificador(furniture: string[], token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_especificador_comodos",
    dados: {
      comodos: furniture.join(", "),
    },
  });

  return response.data;
}

export async function sendIfIsTheFirstPurchaseEspecificador(
  answer: "sim" | "nao",
  token: string
) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_especificador_primeira_compra",
    dados: { primeira_compra: answer },
  });
  return response.data;
}

export async function sendIfIsTheFirstPurchase(
  answer: "sim" | "nao",
  token: string
) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_primeira_compra",
    dados: { primeira_compra: answer },
  });
  return response.data;
}

export async function getStates(token: string) {
  const response = await axios.post(`${apiUrl}${resources.GET_STATES}`, {
    token,
  });

  return response.data;
}

export async function sendInvestiment(answer: string, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_investimento",
    dados: {
      investimento: answer,
    },
  });

  return response.data;
}

export async function sendInvestimentEspecificador(answer: string, token: string) {
  const response = await axios.post(`${apiUrl}${resources.SEND_ANSWER}`, {
    token,
    etapa: "etapa_especificador_investimento",
    dados: {
      investimento: answer,
    },
  });

  return response.data;
}